/* eslint-disable max-len */
import * as React from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
//import LogoFundacionBlanco from '../../img/logo-jda.png';

import './Footer.css';

export default function Footer() {
  const MAILTO = 'csvs@clinbioinfosspa.es';
  const SUBJECT = 'virus-beacon: ...';
  const BODY = 'Info about Biomedical Data Integration demo.';

  return (
    <footer className="content">
      <div className="footer">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid size={{ md: 7 }} style={{ textAlign: 'center' }}>
              <div className="copyright-text">
                <p>
                  <span style={{ color: '#fff' }}>Copyright</span> ©{' '}
                  {new Date().getFullYear()}
                  <a
                    href="https://www.clinbioinfosspa.es/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {' '}
                    Andalusian Platform for Computational Medicine
                  </a>
                </p>
              </div>
            </Grid>
            <Grid size={{ md: 5 }} style={{ textAlign: 'center' }}>
              <div className="social-icons">
                <ul>
                  <li>
                    <a
                      className="logo"
                      target="_blank"
                      rel="noreferrer"
                      title="Andalusian Platform for Computational Medicine"
                      href="https://www.clinbioinfosspa.es/"
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/logo-jda.png`}
                        alt="cba logo"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      className="mail"
                      title={`mailto:${MAILTO}`}
                      href={`mailto:${MAILTO}?subject=${SUBJECT}&body=${BODY}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FontAwesomeIcon icon={faEnvelope} />
                    </a>
                  </li>
                  <li>
                    <a
                      className="twitter"
                      title="Twitter"
                      href="https://twitter.com/ClinicalBioinfo"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FontAwesomeIcon icon={faXTwitter} />
                    </a>
                  </li>
                  <li>
                    <a
                      className="youtube"
                      title="Youtube"
                      href="https://www.youtube.com/channel/UC7liwOO2B9NS0i0_YjBHZ6w"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FontAwesomeIcon icon={faYoutube} />
                    </a>
                  </li>
                </ul>
              </div>
            </Grid>
          </Grid>
        </Box>

        {/*<div className="row">
                    <div className="col-md-7">
                        <div className="copyright-text">
                            <p><span style={{ color: '#fff' }}>Copyright</span> © {new Date().getFullYear()}
                            <a href="https://www.clinbioinfosspa.es/"
                               target="_blank" rel="noreferrer"> Andalusian Platform for Computational Medicine</a></p>
                        </div>
                    </div>
                    <div className="col-md-5">
                        <div className="social-icons">
                            <ul>
                                <li>
                                    <a style={{ background: 'transparent' }} target="_blank" rel="noreferrer"
                                       title="Andalusian Platform for Computational Medicine"
                                       href="https://www.clinbioinfosspa.es/">
                                        <span><img src={LogoFundacionBlanco} alt="cba logo" /></span>
                                    </a>
                                </li>
                                 <li>
                                   <a style={{ backgroundColor: 'transparent' }}
                                       title={`mailto:${MAILTO}`}
                                       href={`mailto:${MAILTO}?subject=${SUBJECT}&body=${BODY}`}
                                       target="_blank" rel="noreferrer"><i className="fa fa-envelope" /></a>
                                 </li>
                                <li>
                                    <a style={{ backgroundColor: '#1991DA' }}
                                       title="Twitter"
                                       href="https://twitter.com/ClinicalBioinfo"
                                       target="_blank" rel="noreferrer"><i className="fa fa-twitter" /></a>
                                </li>
                                <li>
                                    <a style={{ backgroundColor: '#FF0001' }}
                                       title="Youtube"
                                       href="https://www.youtube.com/channel/UC7liwOO2B9NS0i0_YjBHZ6w" target="_blank"
                                       rel="noreferrer"><i className="fa fa-youtube" /></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>*/}
      </div>
    </footer>
  );
}
